import React from 'react';

const SvgRemove = props => (
  <svg
    width={8}
    height={8}
    viewBox="0 0 8 8"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M4 3.404L7.28.124a.422.422 0 1 1 .596.596L4.596 4l3.28 3.28a.422.422 0 1 1-.596.596L4 4.596.72 7.876a.422.422 0 1 1-.596-.596L3.404 4 .124.72A.422.422 0 1 1 .72.124L4 3.404z"
      fill="#046FE2"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgRemove;
